import {
  ArrowDown,
  ArrowUpRight,
  CheckCircle2,
  Church,
  HeartHandshake,
  LockKeyhole,
  ReceiptText,
  Sparkles,
} from "lucide-react";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { homeUrl } from "@/lib/assets";

const givingOptions = [
  {
    number: "01",
    title: "Donar a AD",
    eyebrow: "Misión nacional",
    description:
      "Apoye el trabajo general de las Asambleas de Dios Costa Rica y las iniciativas que fortalecen a la iglesia en todo el país.",
    detail: "Una contribución destinada a sostener la misión, el acompañamiento y el desarrollo institucional.",
    icon: Church,
  },
  {
    number: "02",
    title: "Cuotas de Ministros",
    eyebrow: "Compromiso ministerial",
    description:
      "Un espacio claro para que ministros acreditados puedan gestionar responsablemente sus cuotas y compromisos con la organización.",
    detail: "La Oficina Nacional confirmará el concepto, periodo y datos requeridos antes de completar el aporte.",
    icon: ReceiptText,
  },
  {
    number: "03",
    title: "Contribuciones a Distintos Ministerios",
    eyebrow: "Aporte designado",
    description:
      "Dirija su contribución hacia el ministerio, departamento o iniciativa de ACAD que desea respaldar de manera específica.",
    detail: "Indique el destino de su aporte para recibir la orientación correspondiente de la Oficina Nacional.",
    icon: HeartHandshake,
  },
];

export default function DonatePage() {
  return (
    <div className="acad-react-page acad-donate-page">
      <Header />

      <main>
        <section className="acad-donate-hero" data-nav="dark">
          <span className="acad-donate-grid" aria-hidden="true" />
          <span className="acad-donate-orbit" aria-hidden="true" />

          <div className="acad-donate-shell acad-donate-hero-inner">
            <div className="acad-donate-hero-kicker">
              <span><Sparkles aria-hidden="true" /> Generosidad con propósito</span>
              <small>ACAD Costa Rica · 2026</small>
            </div>

            <div className="acad-donate-hero-copy">
              <span className="acad-donate-eyebrow">Dar transforma</span>
              <h1>
                Generosidad que
                <span>impulsa la misión.</span>
              </h1>
              <p>
                Cada aporte fortalece el servicio de la iglesia, acompaña a sus ministros y ayuda
                a extender el Evangelio a nuevas comunidades.
              </p>
            </div>

            <div className="acad-donate-hero-bottom">
              <a href="#opciones">Conocer las opciones <ArrowDown aria-hidden="true" /></a>
              <div>
                <LockKeyhole aria-hidden="true" />
                <span>Orientación directa de la Oficina Nacional</span>
              </div>
            </div>
          </div>

          <span className="acad-donate-outline" aria-hidden="true">DAR</span>
        </section>

        <section className="acad-donate-intro">
          <div className="acad-donate-shell acad-donate-intro-grid">
            <span className="acad-donate-eyebrow acad-donate-eyebrow--dark">Tres formas de aportar</span>
            <div>
              <h2>Elija el propósito de su contribución.</h2>
              <p>
                Seleccione la opción correspondiente y la Oficina Nacional le brindará los datos
                vigentes para realizar su aporte correctamente.
              </p>
            </div>
          </div>
        </section>

        <section className="acad-donate-options" id="opciones">
          <div className="acad-donate-shell acad-donate-option-grid">
            {givingOptions.map((option) => {
              const Icon = option.icon;

              return (
                <article className="acad-donate-option-card" key={option.number}>
                  <div className="acad-donate-option-top">
                    <span>{option.number}</span>
                    <i><Icon aria-hidden="true" /></i>
                  </div>
                  <small>{option.eyebrow}</small>
                  <h3>{option.title}</h3>
                  <p>{option.description}</p>
                  <div className="acad-donate-option-detail">
                    <CheckCircle2 aria-hidden="true" />
                    <span>{option.detail}</span>
                  </div>
                  <a href={homeUrl("contacto/?tema=donaciones#contacto-formulario")}>
                    Solicitar datos para aportar <ArrowUpRight aria-hidden="true" />
                  </a>
                </article>
              );
            })}
          </div>
        </section>

        <section className="acad-donate-assurance" data-nav="dark">
          <div className="acad-donate-shell acad-donate-assurance-inner">
            <div className="acad-donate-assurance-icon"><LockKeyhole aria-hidden="true" /></div>
            <div>
              <span className="acad-donate-eyebrow">Antes de realizar su aporte</span>
              <h2>Confirme siempre los datos vigentes.</h2>
              <p>
                Para proteger su contribución, solicite a la Oficina Nacional la cuenta, concepto
                y referencia correctos. ACAD no pide contraseñas ni códigos personales.
              </p>
            </div>
            <a href={homeUrl("contacto/?tema=donaciones#contacto-formulario")}>
              Contactar a ACAD <ArrowUpRight aria-hidden="true" />
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
